module.exports = __webpack_public_path__ + "static/media/bg4.465c808b.png";